/**
 * Configuration for all procedure step types
 * Defines fields, validation rules, and default options for each step type
 *
 * Step type definitions are imported from stepTypes.js
 */

import { getStepTypesList } from './stepTypes';

export const STEP_TYPES = getStepTypesList();

export const STEP_OPTIONS_CONFIG = {
  TEXT_INPUT: {
    fields: ['validation_rules'],
    validation_rules: {
      min_length: 10,
      max_length: 2000,
      pattern: '',
      pattern_message: '',
    },
  },
  NUMBER_INPUT: {
    fields: [],
  },
  FILE_UPLOAD: {
    fields: ['validation_rules'],
    validation_rules: {
      allowed_types: ['image/jpeg', 'image/png'],
      max_size_mb: 10,
    },
  },
  YES_NO: {
    fields: ['options'],
    options: {
      yes_label: 'Yes',
      no_label: 'No',
      default_value: 'yes',
    },
  },
  MULTIPLE_CHOICE: {
    fields: ['options'],
    options: {
      choices: [],
      allow_multiple: false,
      default_value: '',
      min_selections: 1,
      max_selections: 3,
    },
  },
  SIGNATURE: {
    fields: ['options'],
    options: {
      canvas_width: 500,
      canvas_height: 200,
      pen_color: '#000000',
      pen_width: 2,
      background_color: '#ffffff',
    },
  },
  AI_IMAGE_ANALYSIS: {
    fields: ['ai_model', 'options'],
    options: {
      confidence_threshold: 0.8,
      auto_proceed: true,
      show_raw_output: false,
    },
  },
  TABLE_GRID: {
    fields: ['options'],
    options: {
      columns: [],
      rows: [], // Array of row objects: { __rowName: string, __defaults: { colId: value, ... } }
    },
  },
  EQUIPMENT_INSPECTION: {
    fields: ['options'],
    options: {
      equipment_types: ['XRAY_GENERATOR_INTRAORAL', 'CBCT', 'PANORAMIC'],
      // Array of { id, label }; defaults to the checks on the official
      // inspection form for X-ray equipment
      checks: [
        { id: 'arm_stable', label: 'Er røntgenarmen stabil i relevante positioner?' },
        { id: 'cabinet_intact', label: 'Er røntgenapparatets kabinet intakt (ingen revner)?' },
        { id: 'control_panel', label: 'Er betjeningspanelet OK?' },
        { id: 'cables', label: 'Er alle ledninger og stik OK?' },
        { id: 'panel_electrical', label: 'Er betjeningspanelet elektrisk OK (tastatur, ledninger)?' },
        { id: 'supplier_items', label: 'Yderligere leverandørforhold, der skal kontrolleres' },
      ],
    },
  },
};

/**
 * Get the default values when a step type is selected
 */
export const getDefaultsForStepType = (stepType) => {
  const config = STEP_OPTIONS_CONFIG[stepType];
  return {
    step_type: stepType,
    validation_rules: config?.fields.includes('validation_rules') ? config.validation_rules : null,
    options: config?.fields.includes('options') ? config.options : null,
    ai_model: config?.fields.includes('ai_model') ? '' : null,
  };
};

/**
 * Get only the relevant fields for a step type
 */
export const getRelevantFields = (stepType, stepData) => {
  const config = STEP_OPTIONS_CONFIG[stepType];
  const result = { ...stepData };

  if (!config.fields.includes('validation_rules')) {
    result.validation_rules = null;
  }
  if (!config.fields.includes('options')) {
    result.options = null;
  }
  if (!config.fields.includes('ai_model')) {
    result.ai_model = null;
  }

  return result;
};
